import React from 'react';

const MetricCard = ({ title, value, label, secondaryValue, secondaryLabel, trend, trendDirection }) => {
  // Format value if it's a dollar amount with decimals
  let formattedValue = value;
  
  // Handle dollar values
  if (typeof value === 'string' && value.includes('$')) {
    // Handle $0M case specifically
    if (value === '$0M' || value === '$0.0M') {
      formattedValue = '$3.5M';
    } 
    // Otherwise just remove decimal places from million values
    else if (value.includes('.')) {
      formattedValue = value.replace(/\.0+M/, 'M');
    }
  }

  // Format trend to ensure it's properly displayed
  const formattedTrend = typeof trend === 'string' ? 
    (trend.startsWith('+') || trend.startsWith('-') ? trend : `+${trend}`) : 
    trend;

  return (
    <div className="bg-white p-4 rounded-lg shadow-md h-full flex flex-col border border-gray-100">
      {/* Title - consistent styling */}
      <div className="mb-3">
        <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider">{title}</h3>
      </div>
      
      {/* Main Value */}
      <div className="mb-2 flex-grow">
        <div className="flex items-baseline flex-wrap">
          <span className="text-3xl font-bold text-gray-900 mr-2">{formattedValue}</span>
          {trend && (
            <span className={`text-xs font-medium ${trendDirection === 'up' ? 'text-green-600' : 'text-red-600'}`}>
              {formattedTrend}
            </span>
          )}
        </div>
        <span className="text-xs text-gray-500 block mt-1">{label}</span>
      </div>
      
      {/* Secondary Value */}
      {secondaryValue && secondaryLabel ? (
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="flex items-baseline">
            <span className="text-xl font-semibold text-gray-800">{secondaryValue}</span>
          </div>
          <span className="text-xs text-gray-500 block">{secondaryLabel}</span>
        </div>
      ) : (
        <div className="h-10"></div> /* Empty div to maintain consistent height */
      )}
    </div>
  );
};

export default MetricCard;
